import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {

    constructor(
      private authService: AuthService,
      private activatedRoute: ActivatedRoute
    ) { }
  

  ngOnInit(): void {
    var userEmail = this.authService.getUserEmail();
    console.log("User email for verification:", userEmail);
    if (!userEmail) {
      console.warn("No user email found for verification.");
      this.authService.navigateToLogin();
    }

    // if the active route code parameter, then send code to user
    var action = this.activatedRoute.snapshot.queryParamMap.get('action');
    if (action === 'send-code') {
      console.log("Requesting email verification code for user:", userEmail);
      // code requested, send code to user email
      this.requestEmailCode();
    }
  }


  confirmEmailCode(code: any) {
    console.log("Confirming email code event", code);
    if (typeof code !== 'string' || code.trim() === '') {
      console.error("Invalid verification code provided");
      return;
    } 

    this.authService.ConfirmUserViaCode(code);
  }

  requestEmailCode() {
    this.authService.RequestEmailVerificationCode().then(() => {
      console.log("Email verification code requested successfully");
    }).catch((error) => {
      console.error("Error requesting email verification code", error);
    });
  }

  getUserEmail() : string {
    return this.authService.getUserEmail() || '';
  }
}
